import { render, staticRenderFns } from "./zhpMark.vue?vue&type=template&id=484410a4&scoped=true&"
import script from "./zhpMark.vue?vue&type=script&lang=js&"
export * from "./zhpMark.vue?vue&type=script&lang=js&"
import style0 from "./zhpMark.vue?vue&type=style&index=0&id=484410a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484410a4",
  null
  
)

export default component.exports